import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  CancelHandler3ic7xysezxbm5 as CancelHandler,
} from './CancellableContinuationImpl.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DispatchedContinuation8kf77e5g2ha2 as DispatchedContinuation } from './internal/DispatchedContinuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CancellableContinuationClass;
function CancellableContinuation() {
  if (CancellableContinuationClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CancellableContinuation', VOID, VOID, [Continuation()]);
    CancellableContinuationClass = $;
  }
  return CancellableContinuationClass;
}
function invokeOnCancellation(_this__u8e3s4, handler) {
  var tmp;
  if (_this__u8e3s4 instanceof CancellableContinuationImpl()) {
    _this__u8e3s4.sz(handler);
    tmp = Unit_instance;
  } else {
    throw UnsupportedOperationException().f1('third-party implementation of CancellableContinuation is not supported');
  }
  return tmp;
}
function disposeOnCancellation(_this__u8e3s4, handle) {
  return invokeOnCancellation(_this__u8e3s4, new (DisposeOnCancel())(handle));
}
var DisposeOnCancelClass;
function DisposeOnCancel() {
  if (DisposeOnCancelClass === VOID) {
    class $ {
      constructor(handle) {
        this.tz_1 = handle;
      }
      uz(cause) {
        return this.tz_1.vz();
      }
      toString() {
        return 'DisposeOnCancel[' + toString(this.tz_1) + ']';
      }
    }
    initMetadataForClass($, 'DisposeOnCancel', VOID, VOID, [CancelHandler()]);
    DisposeOnCancelClass = $;
  }
  return DisposeOnCancelClass;
}
function getOrCreateCancellableContinuation(delegate) {
  if (!(delegate instanceof DispatchedContinuation())) {
    return new (CancellableContinuationImpl())(delegate, 1);
  }
  var tmp0_safe_receiver = delegate.c10();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver.d10()) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return new (CancellableContinuationImpl())(delegate, 2);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
//region block: exports
export {
  CancellableContinuation as CancellableContinuationpb2x00mxmcbt,
  disposeOnCancellation as disposeOnCancellation302lv5bib5mna,
  getOrCreateCancellableContinuation as getOrCreateCancellableContinuation2t1o0dr9l9i36,
  invokeOnCancellation as invokeOnCancellationb68niwbjdmgy,
};
//endregion

//# sourceMappingURL=CancellableContinuation.mjs.map
